import React, {FC, forwardRef} from 'react';

import {cn} from '@bem-react/classname';
import {InputControlSize, InputControlView, TextArea, TextInput} from '@gravity-ui/uikit';
import QuestionLayout, {QuestionLayoutType} from 'ui/components/QuestionLayout';
import getTextInputAria from 'ui/utils/getTextInputAria';

import SuggestText from '../SuggestText';

import {multilinePositions} from './TextQuestion.constants';
import {TextQuestionProps} from './TextQuestion.types';

import './TextQuestion.scss';

const cnTextQuestion = cn('TextQuestion');

const TextQuestion: FC<TextQuestionProps> = forwardRef<HTMLSpanElement, TextQuestionProps>(
    function TextQuestion({getItems, label, error, multiline, ...props}, ref) {
        const commonInputProps = {
            size: 'l' as InputControlSize,
            view: 'normal' as InputControlView,
            hasClear: true,
            id: props.name,
            ref,
            controlProps: {
                className: cnTextQuestion('InputControl', {multiline}),
                ...getTextInputAria(props.required, Boolean(error), props.id),
            },
            ...props,
            className: cnTextQuestion('Input', {multiline}),
        };
        const input = multiline ? (
            <TextArea minRows={6} {...commonInputProps} />
        ) : (
            <TextInput {...commonInputProps} />
        );
        return (
            <QuestionLayout
                {...props}
                label={label}
                error={typeof error === 'string' ? error : undefined}
                type={QuestionLayoutType.Column}
                className={cnTextQuestion('', [props.className])}
                positions={multiline ? multilinePositions : undefined}
                control={
                    getItems ? (
                        <SuggestText
                            onUpdate={props.onUpdate}
                            getItems={getItems}
                            text={props.value ?? ''}
                            applicableInputValue
                            onInputEnterKeyDown={props.onUpdate}
                            error={Boolean(error)}
                        />
                    ) : (
                        input
                    )
                }
            />
        );
    },
);
export default TextQuestion;
